import UpdatePageModal from './UpdatePageModal/UpdatePageModal.css';
export default {
    UpdatePageModal
};
